// extracted by mini-css-extract-plugin
export default {"pageWrap":"yd-z","fullWidth":"zd-z","heading":"Ad-z","fullBleed":"Bd-z","hidden":"Cd-z"};